/* eslint-disable */
import { Alert, Button, SelectChangeEvent } from "@mui/material";
import { Checkbox, Grid, Paper, MenuItem, Select } from "@mui/material";
import { useState, useEffect, useCallback, useContext, Suspense, useMemo, useRef } from "react";
import { CustomInput, CustomSelectInput } from "../../../../shared/CustomInput";
import { CoveredDependents } from "../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../shared/enrollment/planCode/PlanHeader";
import {
	AuthContext,
	EligibleDependentContext,
	GroupEnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../contexts";
import { CoverageDetails } from "../../../../shared/enrollment";
import { useHistory, useLocation } from "react-router-dom";
import CONTACT_LABELS from "../../../../../constants/contactLabels";
import { dateTimeZoneConverter, manualDateComparator } from "../../../../../utils/commonFunctions/date";

import LinkIcon from "@mui/icons-material/Link";

import "./enrollmentPlanForm.css";
import { PlanFormProps } from "../../../../../types/components/enrollmentProps.types";
import { getEligibleDependents } from "../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Member } from "../../../../../types/employee.types";
import { PremiumRateCoverage } from "../../../../../types/plan.types";
import { numberToDollarStr } from "../../../../../utils/commonFunctions/dollar";
import { CommonDetails, CoverageCode, StandardDetails } from "../../../../../types/enrollment.types";
import { RELATIONSHIP } from "../../../../../constants/relationship";
import { AddEnrollmentPayload } from "../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../utils/api";
import { EligiblityDialogProps } from "../../../../../types/components/eligiblityDialogProps.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType } from "../../../../../types/components/dialogProps.types";
import { DisclaimerTable, LazyCustomFormDialog, LazyCustomTextAreaInput } from "../../../../shared";
import { getCurrentDate } from "../../../../../utils/commonFunctions/date";
import EligiblityDialog from "../../../VEBEnrollment/eligiblityDialogs/EligiblityDialog";
import { Health_Plan_Brochure_SBC } from "../../../../../assets";
import ExistsEnrollmentModel from "../../../../shared/existsMemberModel/ExistsEnrollmentModel";
import ExistsDependentModel from "../../../../shared/existsMemberModel/ExistDependentModel";
import { set, sub } from "date-fns";
import { CommonBeneficiaryProps } from "../../../../../types/gliForm.types";
import BeneficaryDetails from "../../plans/gli/GLIFormV2/BeneficaryDetails/BeneficaryDetails";
import HeaderSection from "../../plans/gli/GLIForm/headerSection/HeaderSection";
import NextSection from "../../plans/gli/GLIForm/nextHeaderSection/NextSection";
import TermsCondition from "../../plans/gli/GLIForm/footerTerms/TermsCondition";
import { trackPromise } from "react-promise-tracker";
// import ReactQuill from "react-quill";

const DynamicEnrollmentPlanForm = ({
	dependents,
	isActiveEnrollment,
	openEnrollment,
	getEnrollmentInitData,
	corePlansForEmployeeClassSpecific,
	setSubmittedEnrollment,
	selectedPlan,
	previousEnrollments
}: any): JSX.Element => {
	// console.log("openEnrollment=====>form=====>", openEnrollment);
	// console.log("corePlansForEmployeeClassSpecific============>", corePlansForEmployeeClassSpecific);
	// console.log("selectedPlan=22222===========>", selectedPlan);
	// coverageHealthPlan()
	const history = useHistory();
	const { member } = useContext(AuthContext);
	const [waiveReason, setWaiveReason] = useState("");
	const [isModelOpen, setIsModelOpen] = useState(false);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const [isDependentExists, setIsDependentExists] = useState(false);
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const { paycheck } = useContext(PaycheckContext);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [subPlancoverageDetails, setSubPlanCoverageDetails] = useState<any[]>([]);
	const [subPlanCoverage, setSubPlanCoverage] = useState<any>({});
	const [subPlanEligibleDependents, setSubPlanEligibleDependents] = useState<Member[]>([]);
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const [coveredDependents, setCoveredDependents] = useState<Member[]>([]);
	const [subPlanCoveredDependents, setSubPlanCoveredDependents] = useState<Member[]>([]);
	const { theme } = useContext(ThemeContext);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const [isAgreed, setIsAgreed] = useState(true);
	const [isWaiveLoading, setIsWaiveLoading] = useState(false);
	const [premiumAmountForAlwaysOpenEnrollment, setPremiumAmountForAlwaysOpenEnrollment] = useState<string | null>(
		"0.0"
	);

	const [beneficieryDetailsList, setBeneficieryDetailsList] = useState<CommonBeneficiaryProps[]>([
		{
			id: 1,
			name: "",
			date_of_birth: "",
			relationship: "",
			SSN: "",
			address: "",
			percentage: "",
			type: ""
		}
	]);

	const { setEligiblity } = useContext(EligibleDependentContext);

	const [basePlanDivision, setBasePlanDivision] = useState<boolean>(true);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		groupPlanName: "Health Plan"
	});
	const [country, setCountry] = useState(["a", "b"]);
	const [subPlan, setSubPlan] = useState<string>("");

	const [basePlan, setBasePlan] = useState<string>("");
	const [basePlanCoverageDetails, setBasePlanCoverageDetails] = useState<any>({});

	const [anotherInsurance, setAnotherInsurance] = useState<any>({
		has_another_group_insurance: false,
		another_group_insurance: null
	});

	const [currentPlanShouldEnroll, setCurrentPlanShouldEnroll] = useState<any>({ enroll: true, message: "" });

	const autoFilledPlanCodeRef = useRef<string | null>(null);

	const [beneficiaryFormKey, setBeneficiaryFormKey] = useState(0);

	const location = useLocation();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const { groupOwner } = useContext(GroupOwnerContext);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateHealthPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);

		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}

		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: {
				...commonDetails,
				agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
				total_premium: 0,
				premium_amount: 0
			}
		};
		// const response = await api.enrollment.addEnrollment(enrollmentPayload);
		const response: any = await api.enrollment.addDynamicEnrollments(enrollmentPayload);
		const step = urlSearchParams.get("step");
		console.log("resp", response);

		setSubmittedEnrollment((prev: any) => ({ ...prev, [selectedPlan.plan_name]: response[0] }));

		await getEnrollmentInitData();
		history.push(`?step=${step}&stage=2`);
		setIsWaiveLoading(false);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveReason]);

	const handleWaiveButtonClick = useCallback(() => {
		setIsWaiveLoading(true);
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () => {
							setIsWaiveLoading(false);
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }));
						}
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, waiveReason]);

	const checkMemberEnrollment = async (member: Member) => {
		const selectedMemberSSN = member?.SSN;
		const employee_SSN = member?.employee_SSN;
		const payload = {
			member_SSN: selectedMemberSSN,
			employee_SSN: employee_SSN,
			base_plan_name: selectedPlan.plan_name
		};
		// console.log("selectedMemberSSN", selectedMemberSSN);
		// console.log("PAYLOADFORTHEEMPLOYEECHECK-->", member.employee_SSN);
		if (!selectedMemberSSN) {
			console.error("No SSN found");
			return;
		}

		try {
			// console.log("APIPAYLOAD--->", selectedMemberSSN);

			const response = await api.member.getExistsMemberEnrollemnt(payload);
			if (response) {
				setIsDependentExists(true);
				setExistsDependentData(response.member);
				setIsModelOpen(true);
				return true;
			}
			// console.log("APIRESPONSEFORTHEHEALTH", response);
		} catch (err) {
			console.error("Error:", err);
		}
	};

	const handleSelectDependent = useCallback(
		async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member, planType: string) => {
			const { checked } = event.target;
			console.log("dependent", dependent);
			if (planType == "basePlan") {
				if (checked === true) {
					await checkMemberEnrollment(dependent);
					setCoveredDependents((prevCoveredDependents: Member[]) =>
						prevCoveredDependents.some((d) => d.SSN === dependent.SSN)
							? prevCoveredDependents
							: [...prevCoveredDependents, dependent]
					);
				} else {
					setIsDependentExists(false);
					setCoveredDependents((prevCoveredDependents: Member[]) => {
						const _selectedDependents = prevCoveredDependents.filter(
							(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
						);
						return _selectedDependents;
					});
				}
			} else if (planType == "subPlan") {
				if (checked === true) {
					// await checkMemberEnrollment(dependent);
					setSubPlanCoveredDependents((prevCoveredDependents: Member[]) =>
						prevCoveredDependents.some((d) => d.SSN === dependent.SSN)
							? prevCoveredDependents
							: [...prevCoveredDependents, dependent]
					);
				} else {
					setIsDependentExists(false);
					setSubPlanCoveredDependents((prevCoveredDependents: Member[]) => {
						const _selectedDependents = prevCoveredDependents.filter(
							(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
						);
						return _selectedDependents;
					});
				}
			}
		},
		[]
	);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				// find the matching premium for the paycheck's frequency
				const premiumObj = premiumRateCoverage.premiums?.find(
					// eslint-disable-next-line
					(p) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
				);

				if (!premiumObj || premiumObj.value == null) {
					return premiumAmount;
				}

				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount = `${numberToDollarStr(Number(premiumObj.value))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount = `${premiumObj.value}%`;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);
	const getPremiumAmountByCoverage = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): number | string => {
			let premiumAmount: number | string = "";
			if (paycheck) {
				// find the matching premium for the paycheck's frequency
				const premiumObj = premiumRateCoverage.premiums?.find(
					// eslint-disable-next-line
					(p) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
				);

				if (!premiumObj || premiumObj.value == null) {
					return premiumAmount;
				}

				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount = Number(premiumObj.value);
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount = Number(premiumObj.value);
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];
		if (openEnrollment === null || paycheck === null) {
			return;
		}
		// console.log(basePlanCoverageDetails, "openEnrollment112233", openEnrollment);
		let {
			plan: { coverage }
		} = openEnrollment;

		// console.log("Coverage==========> 22222", coverage);

		if (basePlanDivision && basePlan != "") {
			coverage = basePlanCoverageDetails.coverage;
		} else if (basePlanDivision && basePlan == "") {
			// setCoverageDetails([]);
			return;
		}

		// if (basePlanCoverageDetails?.coverage) {
		// 	coverage = basePlanCoverageDetails.coverage;
		// } BBI - 432988548 //PL - 454993156

		// console.log("Coverage==========>", coverage);

		// if (coverage.EE?.active) {
		// 	_coverageDetails.push({
		// 		coverage: "Employee Only",
		// 		premiumAmount: getPremiumAmount(coverage.EE)
		// 	});
		// }
		// if (coverage.ED?.active) {
		// 	if (coverage.ECH?.active) {
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Children",
		// 			premiumAmount: getPremiumAmount(coverage.ECH)
		// 		});
		// 	}
		// 	if (coverage.ES?.active) {
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Spouse",
		// 			premiumAmount: getPremiumAmount(coverage.ES)
		// 		});
		// 	}
		// 	_coverageDetails.push({
		// 		coverage: "Coverage For All Dependent irrespective of relationship type",
		// 		premiumAmount: getPremiumAmount(coverage.ED)
		// 	});
		// } else {
		// 	if (coverage.ES?.active) {
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Spouse",
		// 			premiumAmount: getPremiumAmount(coverage.ES)
		// 		});
		// 	}
		// 	if (coverage.EC?.active) {
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For One Child",
		// 			premiumAmount: getPremiumAmount(coverage.EC)
		// 		});
		// 	}
		// 	if (coverage.ECH?.active) {
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Two or More Children",
		// 			premiumAmount: getPremiumAmount(coverage.ECH)
		// 		});
		// 	}
		// }

		const coverageConfig = [
			{
				key: "EE",
				label: "Employee Only"
			},
			{
				key: "ES",
				label: "Coverage For Spouse"
			},
			{
				key: "EC",
				label: "Coverage For One Child"
			},
			{
				key: "ECH",
				label: "Coverage For Children(s)"
			},
			{
				key: "ED",
				label: "Coverage For All Dependent irrespective of relationship type"
			}
		];

		coverageConfig.forEach(({ key, label }) => {
			if (coverage?.[key]?.active) {
				_coverageDetails.push({
					coverage: label,
					premiumAmount: getPremiumAmount(coverage[key])
				});
			}
		});

		// console.log("_coverageDetails=====>", _coverageDetails);

		setCoverageDetails([..._coverageDetails]);
	}, [getPremiumAmount, openEnrollment, paycheck, selectedPlan, basePlanCoverageDetails, basePlanDivision]);

	const getSubPlanCoverageDetails = useCallback(() => {
		if (!selectedPlan?.internal_dependencies?.length || !subPlan || openEnrollment === null) return;

		// Find the selected sub plan
		// const selectedSubPlan = selectedPlan.internal_dependencies.find((dep: any) => dep.sub_plan.name === subPlan);
		const selectedSubPlan = openEnrollment.plan.internal_dependencies.find(
			(dep: any) => dep.sub_plan.name === subPlan
		);

		if (!selectedSubPlan) return;

		const coverage = selectedSubPlan.sub_plan.coverage;
		const _coverageDetails: any[] = [];

		if (coverage.EE?.active) {
			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount: getPremiumAmount(coverage.EE)
			});
		}
		if (coverage.ED?.active) {
			_coverageDetails.push({
				coverage: "Coverage For All Dependent irrespective of relationship type",
				premiumAmount: getPremiumAmount(coverage.ED)
			});
		} else {
			if (coverage.ES?.active) {
				_coverageDetails.push({
					coverage: "Coverage For Spouse",
					premiumAmount: getPremiumAmount(coverage.ES)
				});
			}
			if (coverage.EC?.active) {
				_coverageDetails.push({
					coverage: "Coverage For One Child",
					premiumAmount: getPremiumAmount(coverage.EC)
				});
			}
			if (coverage.ECH?.active) {
				_coverageDetails.push({
					coverage: "Coverage For Two or More Children",
					premiumAmount: getPremiumAmount(coverage.ECH)
				});
			}
		}
		setSubPlanCoverageDetails(_coverageDetails);
		setSubPlanCoverage(coverage);
		const dependentCoverage = getEligibleDependents(
			dependents,
			coverage,
			openEnrollment.plan.dependent_eligibility
		);
		// console.log("dependentCoverage for subplan===>", dependentCoverage);
		setSubPlanEligibleDependents([...dependentCoverage.eligibleDependents]);
	}, [getPremiumAmount, selectedPlan, subPlan, dependents, openEnrollment]);
	// }, [getPremiumAmount, selectedPlan, subPlan]);

	// const getPremiumRateByFixed = useCallback(
	// 	(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
	// 		if (paycheck === null) {
	// 			return null;
	// 		}
	// 		let premiumAmount: number | null = null;
	// 		if (paycheck.pay_frequency === "MONTHLY") {
	// 			premiumAmount = coverageCode.monthly_premium as number;
	// 		} else if (paycheck.pay_frequency === "WEEKLY") {
	// 			premiumAmount = coverageCode.weekly_premium as number;
	// 		}
	// 		return premiumAmount;
	// 	},
	// 	[paycheck]
	// );

	// const getPremiumRateByPercentage = useCallback(
	// 	(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
	// 		if (paycheck === null) {
	// 			return null;
	// 		}
	// 		let premiumAmount: number | null = null;
	// 		if (paycheck.pay_frequency === "MONTHLY") {
	// 			premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
	// 			if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
	// 				premiumAmount = coverageCode.monthly_maximum_premium as number;
	// 			} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
	// 				premiumAmount = coverageCode.monthly_minimum_premium as number;
	// 			}
	// 		} else if (paycheck.pay_frequency === "WEEKLY") {
	// 			premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
	// 			if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
	// 				premiumAmount = coverageCode.weekly_maximum_premium as number;
	// 			} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
	// 				premiumAmount = coverageCode.weekly_minimum_premium as number;
	// 			}
	// 		}
	// 		return premiumAmount;
	// 	},
	// 	[paycheck]
	// );

	// const calculatePremiumByCoverage = useCallback(
	// 	(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
	// 		if (openEnrollment === null || paycheck === null) {
	// 			return null;
	// 		}

	// 		let premiumAmount: number | null;
	// 		if (coverageCode.active === false) {
	// 			alert("Member is not covered in this plan");
	// 			return null;
	// 		}
	// 		if (coverageCode.premium_type === "PERCENTAGE") {
	// 			premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
	// 		} else if (coverageCode.premium_type === "FIXED") {
	// 			premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
	// 		} else {
	// 			alert("Invalid premium type");
	// 			return null;
	// 		}
	// 		return premiumAmount;
	// 	},
	// 	[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	// );

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) return null;

			const premiumObj = coverageCode.premiums.find(
				// eslint-disable-next-line
				(p) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
			);
			if (!premiumObj || premiumObj.value == null) return null;

			return premiumObj.value;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) return null;

			const premiumObj = coverageCode.premiums.find(
				// eslint-disable-next-line
				(p) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
			);
			if (!premiumObj || premiumObj.value == null) return null;

			let premiumAmount = basePayRate * (premiumObj.value / 100);

			if (premiumObj.maximum !== null && premiumObj.maximum !== undefined) {
				premiumAmount = Math.min(premiumAmount, premiumObj.maximum);
			}
			if (premiumObj.minimum !== null && premiumObj.minimum !== undefined) {
				premiumAmount = Math.max(premiumAmount, premiumObj.minimum);
			}

			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			// console.log(basePayRate, "calculatePremiumByCoverage=====>", coverageCode);
			if (openEnrollment === null || paycheck === null) return null;
			if (!coverageCode?.active || !coverageCode) return null;

			if (coverageCode.premium_type === "PERCENTAGE") {
				return getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				return getPremiumRateByFixed(basePayRate, coverageCode);
			}
			return null;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const calculatePremium = useCallback(() => {
		if ((!selectedPlan.is_always_open && openEnrollment === null) || paycheck === null) {
			return null;
		}


		if (selectedPlan.has_employee_custom_contribution) {
			return null;
		}

		if (basePlanDivision && basePlan == "") {
			setEnrollmentStandardDetails(Object.assign([], []));
			setDependentPremium(0);
			setTotalPremium(0);
			setEmployeePremium(0);
			return null;
		}

		let selectedPlanCoverage: any;

		if (!basePlanDivision) {
			selectedPlanCoverage = openEnrollment.plan.coverage;
		} else if (basePlanDivision && basePlan != "" && Object.keys(basePlanCoverageDetails).length > 0) {
			selectedPlanCoverage = basePlanCoverageDetails.coverage;
		} else if ((basePlanDivision && Object.keys(basePlanCoverageDetails).length == 0) || !basePlanCoverageDetails) {
			setEnrollmentStandardDetails(Object.assign([], []));
			setDependentPremium(0);
			setTotalPremium(0);
			setEmployeePremium(0);
			return null;
		} else {
			// setEnrollmentStandardDetails(Object.assign([], []));
			// setDependentPremium(0);
			// setTotalPremium(0);
			// setEmployeePremium(0);
			// return null;
		}

		console.log(basePlanCoverageDetails, basePlanDivision, "basePlanCoverageDetails", basePlan);
		let coveredChildren: Member[] = [];
		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | any = null;
		// let basePayRate: number;
		// if (paycheck?.pay_frequency === "WEEKLY") {
		// 	basePayRate = paycheck.weekly_base_rate;
		// } else if (paycheck?.pay_frequency === "MONTHLY") {
		// 	basePayRate = paycheck.monthly_base_rate;
		// } else {
		// 	alert("Invalid Pay Frequency");
		// 	return;
		// }
		// eslint-disable-next-line
		let basePayRate = paycheck.base_pay_rate;

		let employeePremium: number | null = 0;

		const selectedSubPlanCoverage = subPlanCoverage;
		// console.log("subPlanCoverage=====>", subPlanCoverage);
		// console.log("subPlanCoverage22=====>", openEnrollment.plan.coverage);
		employeePremium = calculatePremiumByCoverage(basePayRate, selectedPlanCoverage.EE);
		console.log("employeePremium=====> 2", employeePremium);
		// console.log("coveredDependents=====>", coveredDependents);
		if (employeePremium === null) {
			return;
		}
		let totalPremium: any = 0;
		// let basePlanPremium:any=0;
		let riderPremium: any = 0;
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});
		let combinedCoverageCode =
			coveredSpouse && coveredChildren.length !== 0
				? "EF"
				: coveredSpouse
				? "ES"
				: coveredChildren.length !== 0
				? "ECH"
				: "EE";
		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;

		// console.log(selectedPlanCoverage, "testtt", selectedSubPlanCoverage);

		// calculation for premium without dependent true for main plan

		if (selectedPlanCoverage?.premium_without_dependent) {
			totalPremium = calculatePremiumByCoverage(basePayRate, selectedPlanCoverage.EE);
		} else if (!selectedPlanCoverage?.premium_without_dependent) {
			const premiumAmount = calculatePremiumByCoverage(basePayRate, selectedPlanCoverage.EE);
			// console.log("Main Plan Premium Amount:", premiumAmount);
			totalPremium = premiumAmount;
		}

		if (coveredDependents.length !== 0 && selectedPlanCoverage?.premium_without_dependent) {
			if (coveredSpouse !== null) {
				const premiumAmount = calculatePremiumByCoverage(
					basePayRate,
					// selectedPlanCoverage.ED?.active ? selectedPlanCoverage.ED : selectedPlanCoverage.ES
					selectedPlanCoverage.ES
				);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails & any = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false,
					sub_plan: basePlan
				};
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = _dependentPremium + premiumAmount;
				totalPremium = totalPremium + premiumAmount;
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const premiumAmount = calculatePremiumByCoverage(
						basePayRate,
						// selectedPlanCoverage.ED?.active ? selectedPlanCoverage.ED : openEnrollment.plan.coverage.EC
						openEnrollment.plan.coverage.EC
					);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const spouseStandardDetails: StandardDetails & any = {
						member_object_id: coveredChildren[0]._id,
						coverage_code: "EC",
						member_SSN: coveredChildren[0].SSN,
						premium_amount: premiumAmount,
						is_tobacco: false,
						sub_plan: basePlan
					};
					_dependentPremium = _dependentPremium + premiumAmount;
					totalPremium = totalPremium + premiumAmount;
					standardDetails.push(spouseStandardDetails);
				} else {
					const premiumAmount = calculatePremiumByCoverage(
						basePayRate,
						// selectedPlanCoverage.ED?.active ? selectedPlanCoverage.ED : openEnrollment.plan.coverage.ECH
						openEnrollment.plan.coverage.ECH
					);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails & any = {
							member_object_id: coveredChild._id,
							coverage_code: "ECH",
							member_SSN: coveredChild.SSN,
							premium_amount: premiumAmount,
							is_tobacco: false,
							sub_plan: basePlan
						};
						standardDetails.push(spouseStandardDetails);
					});
					totalPremium = totalPremium + premiumAmount;
					_dependentPremium = _dependentPremium + premiumAmount;
				}
			}
			// setEnrollmentStandardDetails(Object.assign([], standardDetails));
			// setDependentPremium(_dependentPremium);
		}

		// calculation for premium without dependent false for main plan
		//-------------------------------------------------------------------------
		// console.log(
		// 	coveredDependents,
		// 	"Main Plan Coverage============>",
		// 	selectedPlanCoverage,
		// 	selectedPlanCoverage[combinedCoverageCode],
		// 	basePayRate
		// );
		if (coveredDependents.length !== 0 && !selectedPlanCoverage?.premium_without_dependent) {
			let premiumCoverage: any = null;

			// spouse + child => family => use ED
			// if (coveredSpouse && coveredChildren.length > 0) {
			// 	premiumCoverage = selectedPlanCoverage.ED;
			// } else if (coveredSpouse) {
			// 	premiumCoverage = selectedPlanCoverage.ES;

			// 	// only child
			// } else if (coveredChildren.length > 0) {
			// 	// your business rule:
			// 	// even 1 child should use ECH
			// 	premiumCoverage = selectedPlanCoverage.ECH;
			// } else {
			// 	premiumCoverage = selectedPlanCoverage.EE;
			// }
			if (
				selectedPlanCoverage?.ED?.active &&
				!selectedPlanCoverage?.ES?.active &&
				!selectedPlanCoverage?.EC?.active &&
				!selectedPlanCoverage?.ECH?.active
			) {
				// only ED available for dependents
				premiumCoverage = selectedPlanCoverage.ED;
			} else if (coveredSpouse && coveredChildren.length > 0) {
				premiumCoverage = selectedPlanCoverage.ED;
			} else if (coveredSpouse) {
				premiumCoverage = selectedPlanCoverage.ES;
				// } else if (coveredChildren.length > 0) {
				// 	// even 1 child uses ECH
				// 	premiumCoverage = selectedPlanCoverage.ECH;
				// } else {
				// 	premiumCoverage = selectedPlanCoverage.EE;
				// }
			} else if (coveredChildren.length > 0) {
				// child logic

				if (coveredChildren.length === 1) {
					// single child

					if (selectedPlanCoverage?.EC?.active) {
						premiumCoverage = selectedPlanCoverage.EC;
					} else if (selectedPlanCoverage?.ECH?.active) {
						premiumCoverage = selectedPlanCoverage.ECH;
					} else if (selectedPlanCoverage?.ED?.active) {
						premiumCoverage = selectedPlanCoverage.ED;
					}
				} else {
					// multiple child

					if (selectedPlanCoverage?.ECH?.active) {
						premiumCoverage = selectedPlanCoverage.ECH;
					} else if (selectedPlanCoverage?.EC?.active) {
						premiumCoverage = selectedPlanCoverage.EC;
					} else if (selectedPlanCoverage?.ED?.active) {
						premiumCoverage = selectedPlanCoverage.ED;
					}
				}
			} else {
				premiumCoverage = selectedPlanCoverage.EE;
			}

			// const resolvedCoverageCode = selectedPlanCoverage?.EC?.active
			// 	? "EC"
			// 	: selectedPlanCoverage?.ECH?.active
			// 	? "ECH"
			// 	: "ED";
			let resolvedCoverageCode = "ED";

			if (coveredChildren.length === 1) {
				if (selectedPlanCoverage?.EC?.active) {
					resolvedCoverageCode = "EC";
				} else if (selectedPlanCoverage?.ECH?.active) {
					resolvedCoverageCode = "ECH";
				}
			} else if (coveredChildren.length > 1) {
				if (selectedPlanCoverage?.ECH?.active) {
					resolvedCoverageCode = "ECH";
				} else if (selectedPlanCoverage?.EC?.active) {
					resolvedCoverageCode = "EC";
				}
			}

			const premiumAmount = calculatePremiumByCoverage(basePayRate, premiumCoverage);
			// const premiumAmount = calculatePremiumByCoverage(
			// 	basePayRate,
			// 	selectedPlanCoverage.ED?.active ? selectedPlanCoverage.ED : selectedPlanCoverage[combinedCoverageCode]
			// );

			if (premiumAmount === null) {
				alert("Invalid Premium Amount");
				return null;
			}
			// console.log("Main Plan Premium Amount:", premiumAmount);
			totalPremium = premiumAmount;

			if (coveredSpouse !== null) {
				const spouseStandardDetails: StandardDetails & any = {
					member_object_id: coveredSpouse._id,
					// coverage_code: "ES",
					coverage_code: selectedPlanCoverage?.ES?.active ? "ES" : "ED",
					member_SSN: coveredSpouse.SSN,
					// premium_amount: premiumAmount,
					premium_amount: getPremiumAmountByCoverage(
						selectedPlanCoverage?.ES?.active ? selectedPlanCoverage.ES : selectedPlanCoverage.ED
					),
					is_tobacco: false,
					sub_plan: basePlan
				};
				standardDetails.push(spouseStandardDetails);
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const spouseStandardDetails: StandardDetails & any = {
						member_object_id: coveredChildren[0]._id,
						// coverage_code: "EC",
						coverage_code: resolvedCoverageCode,
						member_SSN: coveredChildren[0].SSN,
						// premium_amount: premiumAmount,
						// premium_amount: getPremiumAmountByCoverage(selectedPlanCoverage.EC ),
						// premium_amount: getPremiumAmountByCoverage(
						// 	selectedPlanCoverage?.EC?.active ? selectedPlanCoverage.EC : selectedPlanCoverage.ED
						// ),
						premium_amount: getPremiumAmountByCoverage(selectedPlanCoverage[resolvedCoverageCode]),
						is_tobacco: false,
						sub_plan: basePlan
					};

					standardDetails.push(spouseStandardDetails);
				} else {
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails & any = {
							member_object_id: coveredChild._id,
							// coverage_code: "ECH",
							coverage_code: resolvedCoverageCode,
							member_SSN: coveredChild.SSN,
							// premium_amount: premiumAmount,
							premium_amount: getPremiumAmountByCoverage(selectedPlanCoverage[resolvedCoverageCode]),
							is_tobacco: false,
							sub_plan: basePlan
						};
						standardDetails.push(spouseStandardDetails);
					});
					// _dependentPremium = premiumAmount;
				}
			}
			// setEnrollmentStandardDetails(Object.assign([], standardDetails));
			// setDependentPremium(_dependentPremium);
		}

		// calculation for premium without dependent true for rider plan
		coveredChildren = [];
		coveredSpouse = null;
		subPlanCoveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});
		combinedCoverageCode =
			coveredSpouse && coveredChildren.length !== 0
				? "EF"
				: coveredSpouse
				? "ES"
				: coveredChildren.length !== 0
				? "ECH"
				: "EE";
		if (subPlan && Object.keys(subPlanCoverage).length > 0 && selectedSubPlanCoverage?.premium_without_dependent) {
			const premiumAmount = calculatePremiumByCoverage(basePayRate, selectedSubPlanCoverage.EE);
			console.log("ttt", basePayRate, selectedSubPlanCoverage);
			if (premiumAmount === null) {
				alert("Invalid Employee SubPlan Premium Amount");
				return null;
			}
			_dependentPremium = _dependentPremium + premiumAmount;
			const employeeStandardDetails: StandardDetails & any = {
				member_object_id: member?._id,
				coverage_code: "EE",
				member_SSN: member?.SSN,
				premium_amount: premiumAmount,
				is_tobacco: false,
				plan_name: subPlan,
				sub_plan: basePlan
			};
			standardDetails.push(employeeStandardDetails);
			riderPremium = premiumAmount;
		}
		if (subPlanCoveredDependents.length !== 0 && selectedSubPlanCoverage?.premium_without_dependent) {
			console.log("gfbhgnhg");
			if (coveredSpouse !== null) {
				const premiumAmount = calculatePremiumByCoverage(
					basePayRate,
					selectedSubPlanCoverage.ED?.active ? selectedSubPlanCoverage.ED : selectedSubPlanCoverage.ES
				);
				if (premiumAmount === null) {
					alert("Invalid SubPlan Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails & any = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false,
					plan_name: subPlan,
					sub_plan: basePlan
				};
				riderPremium = riderPremium + premiumAmount;
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = _dependentPremium + premiumAmount;
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const premiumAmount = calculatePremiumByCoverage(
						basePayRate,
						selectedSubPlanCoverage.ED?.active ? selectedSubPlanCoverage.ED : selectedSubPlanCoverage.EC
					);
					if (premiumAmount === null) {
						alert("Invalid SubPlan Premium Amount");
						return null;
					}
					const spouseStandardDetails: StandardDetails & any = {
						member_object_id: coveredChildren[0]._id,
						coverage_code: "EC",
						member_SSN: coveredChildren[0].SSN,
						premium_amount: premiumAmount,
						is_tobacco: false,
						plan_name: subPlan,
						sub_plan: basePlan
					};
					riderPremium = riderPremium + premiumAmount;
					_dependentPremium = _dependentPremium + premiumAmount;
					standardDetails.push(spouseStandardDetails);
				} else {
					const premiumAmount = calculatePremiumByCoverage(
						basePayRate,
						selectedSubPlanCoverage.ED?.active ? selectedSubPlanCoverage.ED : selectedSubPlanCoverage.ECH
					);
					if (premiumAmount === null) {
						alert("Invalid SubPlan Premium Amount");
						return null;
					}
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails & any = {
							member_object_id: coveredChild._id,
							coverage_code: "ECH",
							member_SSN: coveredChild.SSN,
							premium_amount: premiumAmount,
							is_tobacco: false,
							plan_name: subPlan,
							sub_plan: basePlan
						};
						standardDetails.push(spouseStandardDetails);
					});

					// assuming ech and ec same in ED covered dependents means no multiplication of number of child into ed coverage value
					riderPremium = riderPremium + premiumAmount;
					_dependentPremium = _dependentPremium + premiumAmount;
				}
			}
		}

		// calculation for premium without dependent false for rider plan
		//-------------------------------------------------------------------------

		if (subPlan && Object.keys(subPlanCoverage).length > 0 && !selectedSubPlanCoverage?.premium_without_dependent) {
			console.log("gfbhgnhg");
			const premiumAmount = calculatePremiumByCoverage(
				basePayRate,
				combinedCoverageCode == "EE"
					? selectedSubPlanCoverage.EE
					: selectedSubPlanCoverage.ED?.active
					? selectedSubPlanCoverage.ED
					: selectedSubPlanCoverage[combinedCoverageCode]
			);

			console.log("ttt", basePayRate, selectedSubPlanCoverage);
			if (premiumAmount === null) {
				alert("Invalid SubPlan Premium Amount");
				return null;
			}
			// totalPremium = totalPremium + premiumAmount;
			riderPremium = premiumAmount;
			_dependentPremium = _dependentPremium + premiumAmount;
			const employeeStandardDetails: StandardDetails & any = {
				member_object_id: member?._id,
				coverage_code: "EE",
				member_SSN: member?.SSN,
				premium_amount: premiumAmount,
				is_tobacco: false,
				plan_name: subPlan,
				sub_plan: basePlan
			};
			standardDetails.push(employeeStandardDetails);
		}
		if (subPlanCoveredDependents.length !== 0 && !selectedSubPlanCoverage?.premium_without_dependent) {
			console.log("gfbhgnhg");
			const premiumAmount = calculatePremiumByCoverage(
				basePayRate,
				selectedSubPlanCoverage.ED?.active
					? selectedSubPlanCoverage.ED
					: selectedSubPlanCoverage[combinedCoverageCode]
			);
			if (premiumAmount === null) {
				alert("Invalid Premium Amount");
				return null;
			}

			if (coveredSpouse !== null) {
				const spouseStandardDetails: StandardDetails & any = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false,
					plan_name: subPlan,
					sub_plan: basePlan
				};
				standardDetails.push(spouseStandardDetails);
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const spouseStandardDetails: StandardDetails & any = {
						member_object_id: coveredChildren[0]._id,
						coverage_code: "EC",
						member_SSN: coveredChildren[0].SSN,
						premium_amount: premiumAmount,
						is_tobacco: false,
						plan_name: subPlan,
						sub_plan: basePlan
					};

					standardDetails.push(spouseStandardDetails);
				} else {
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails & any = {
							member_object_id: coveredChild._id,
							coverage_code: "ECH",
							member_SSN: coveredChild.SSN,
							premium_amount: premiumAmount,
							is_tobacco: false,
							plan_name: subPlan,
							sub_plan: basePlan
						};
						standardDetails.push(spouseStandardDetails);
					});
					_dependentPremium = _dependentPremium + premiumAmount;
				}
			}
		}
		setEnrollmentStandardDetails(Object.assign([], standardDetails));
		setDependentPremium(_dependentPremium);
		// console.log(_dependentPremium, "_dependentPremium=====>", employeePremium, riderPremium);
		setTotalPremium(totalPremium + riderPremium);
		setEmployeePremium(employeePremium);
	}, [
		calculatePremiumByCoverage,
		coveredDependents,
		openEnrollment,
		paycheck,
		subPlan,

		subPlanCoveredDependents,
		subPlanCoverage,
		basePlan,
		basePlanDivision,
		basePlanCoverageDetails
	]);
	// console.log("ISTRUECHECK1--->", isDependentExists);
	const validateGLIBeneficieryDetails = useCallback((beneficiery, type) => {
		// console.log("Beneficiery", beneficiery);
		// console.log("Type", type);
		let sum = 0;
		let _dob;
		let isValid = true;

		let primary_found = false;
		let contingent_found = false;
		let sum_contingent_beneficiery = 0;

		let is_alert = false;

		for (let i = 0; i < beneficiery.length; i++) {
			// console.log("enrollmentPayload============> 222", beneficiery[i]);
			delete beneficiery[i]["id"];
			const { name, date_of_birth, relationship, percentage, address, SSN, type } = beneficiery[i];
			if (type == "primary_beneficiery") {
				primary_found = true;
				sum = sum + parseInt(percentage);
			}
			if (type == "contingent_beneficiery") {
				contingent_found = true;
				sum_contingent_beneficiery = sum_contingent_beneficiery + parseInt(percentage);
			}
			if (
				name !== "" &&
				date_of_birth !== "" &&
				relationship !== "" &&
				percentage !== "" &&
				address !== "" &&
				SSN !== "" &&
				type !== ""
			) {
				const cleanSSN = SSN.replace(/-/g, "");
				if (!/^\d{9}$/.test(cleanSSN)) {
					alert(`Invalid SSN in ${type}.`);
					isValid = false;
					is_alert = true;
					return isValid;
				}
				_dob = date_of_birth.split("/");
				if (_dob[2].length < 4) {
					alert(`Invalid year in ${type}. Valid date format MM/DD/YYYY`);
					isValid = false;
					is_alert = true;
					return isValid;
				}
			} else if (
				name === "" ||
				date_of_birth === "" ||
				relationship === "" ||
				percentage === "" ||
				address === "" ||
				SSN === "" ||
				type == ""
			) {
				isValid = false;
				is_alert = true;
				alert(`Please fill all the field ${type}`);
				break;
			} else {
				isValid = false;
				is_alert = true;
				alert(`Please fill all the field ${type}`);
				break;
			}
		}
		// console.log("Beneficiery", beneficiery);
		// console.log("Type", type);
		if (!primary_found && !is_alert) {
			isValid = false;
			alert("You must have at least one primary beneficiery");
			return isValid;
		}
		if (sum_contingent_beneficiery !== 100 && sum_contingent_beneficiery !== 0 && contingent_found && !is_alert) {
			isValid = false;
			alert("Total percentage must equal to 100 contingent_found");
			return isValid;
		}
		if (sum !== 100 && sum !== 0 && primary_found && !is_alert) {
			isValid = false;
			alert("Total percentage must equal to 100 primary_found");
			return isValid;
		}
		return isValid;
	}, []);
	const handleActivateButtonClick = useCallback(async () => {
		// Check if any dependents are selected
		// console.log("ISTRUECHECK2--->", isDependentExists);
		// if (!totalPremium || Number(totalPremium) < 0) {
		// 	alert("Please select a Base Plan. Total premium should not be less than $0.");
		// 	return;
		// }
		if (!currentPlanShouldEnroll.enroll) {
			alert(currentPlanShouldEnroll.message);
			return;
		}
		if (!isAgreed) {
			alert("Please agree to the terms and conditions before submitting.");
			return;
		}
		if (isDependentExists === true) {
			// alert(`Please deselect the dependent${existsDependentData.first_name} to proceed`);
			setIsDependentExistsModelOpen(true);
			return; // Exit the function early if a dependent exists
		}

		const contigentBeneficiaries = beneficieryDetailsList.filter(
			(benficiary: any) => benficiary.type == "contingent_beneficiery"
		);
		const primaryBeneficiaries = beneficieryDetailsList.filter(
			(benficiary: any) => benficiary.type == "primary_beneficiery"
		);
		if (selectedPlan.beneficiaries_required) {
			const isPrimaryBeneficieryDetailsValid = validateGLIBeneficieryDetails(beneficieryDetailsList, "primary");
			if (isPrimaryBeneficieryDetailsValid === false) {
				return;
			}
		}
		if (member === null || openEnrollment === null) {
			return;
		}

		const primary_beneficiery = primaryBeneficiaries.map((item: any) => {
			delete item["type"];
			return item;
		});
		const contingent_beneficiery = contigentBeneficiaries.map((item: any) => {
			delete item["type"];
			return item;
		});

		if (selectedPlan.has_premium && (!totalPremium || Number(totalPremium) <= 0)) {
			alert("Total premium amount cannot be less than or equal to zero.if has base plan,please select that");
			return;
		}
		// custom contribution followed by min limit
		// if (
		// 	selectedPlan.custom_contribution_of_employees &&
		// 	totalPremium < selectedPlan.custom_contribution_of_employees.min_limit
		// ) {
		// 	alert(
		// 		`The contribution amount must be at least $${selectedPlan.custom_contribution_of_employees.min_limit}`
		// 	);
		// 	return;
		// }
		if (selectedPlan.has_employee_custom_contribution) {
			const minLimit = getMinContributionByPayFrequency(
				selectedPlan.custom_contribution_of_employees,
				paycheck?.pay_frequency
			);

			if (minLimit > 0 && totalPremium < minLimit) {
				alert(
					`The contribution amount must be at least $${minLimit} per ${paycheck?.pay_frequency.toLowerCase()}`
				);
				return;
			}
		}

		const currentDate = new Date() as unknown as string;
		const planStartDate = openEnrollment.plan.start_date; // -1 or 0
		const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

		const effectiveDate = openEnrollment.plan.auto_approve
			? planDateComparison === -1 || planDateComparison === 0
				? getCurrentDate()
				: null
			: null;

		const _another_group_insurance: string = anotherInsurance.another_group_insurance
			? anotherInsurance.another_group_insurance.replace(/\n/g, " ")
			: "";

		const subPlans = openEnrollment?.plan?.internal_dependencies?.map((sp: any) => sp.sub_plan) || [];

		const enrollmentCommonDetails: CommonDetails = {
			agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
			location_number: member.location.location_number,
			location_name: member.location.location_name,
			group_number: member.group_number,
			group_name: member.group.name,
			plan_object_id: openEnrollment.plan._id,
			plan_code: openEnrollment.plan.plan_code,
			plan_name: openEnrollment.plan.plan_name,
			base_plan_name: openEnrollment.plan.plan_name,
			insured_object_id: member._id,
			insured_SSN: member.SSN,
			writing_number: 0,
			unenrolled_reason: null,
			waive_reason: null,
			termination_reason: null,
			enrollment_date: getCurrentDate(),
			effective_date: effectiveDate,
			termination_date: null,
			open_enrollment_id: openEnrollment._id,
			total_premium: totalPremium.toFixed(2) as unknown as number,
			another_group_insurance: _another_group_insurance,
			enrollment_status: selectedPlan.auto_approve ? "ACTIVE" : "SUBMITTED",
			// sub_plan: subPlans.length > 0 ? subPlans : null
			sub_plan: basePlan,
			primary_beneficiery,
			contingent_beneficiery
		};
		//
		// const childrenRelationships: string[] = [
		// 	RELATIONSHIP.child,
		// 	RELATIONSHIP.disabled_child,
		// 	RELATIONSHIP.legal_custody_child,
		// 	RELATIONSHIP.stepchild,
		// 	RELATIONSHIP.court_ordered_dependent,
		// 	RELATIONSHIP.grandchild
		// ];
		const childrenRelationships: string[] =
			selectedPlan?.dependent_eligibility?.map((dep: { relationship_type: string }) =>
				dep.relationship_type.toUpperCase()
			) || [];

		let coveredSpouse: Member | any = null;
		const coveredChildren: Member[] = [];
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});

		const coverageCode =
			coveredSpouse === null && coveredChildren.length === 0
				? "EE"
				: coveredSpouse && coveredChildren.length !== 0
				? "EF"
				: coveredSpouse
				? "ES"
				: "ECH";

		const enrollmentPayload: AddEnrollmentPayload = {
			common_details: enrollmentCommonDetails,
			standard_details: [
				...enrollmentStandardDetails,
				{
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount: selectedPlan.has_employee_custom_contribution
						? (totalPremium.toFixed(2) as unknown as number)
						: (employeePremium.toFixed(2) as unknown as number),

					is_tobacco: false
				}
			]
		};

		// console.log("enrollmentPayload============>", enrollmentPayload);

		// const resp = await api.enrollment.addEnrollment(enrollmentPayload);
		const resp: any = await api.enrollment.addDynamicEnrollments(enrollmentPayload);
		await getEnrollmentInitData();
		const step = urlSearchParams.get("step");

		// console.log("resp", resp);
		if (selectedPlan.auto_approve) {
			await getEnrollmentInitData();
		}
		setSubmittedEnrollment((prev: any) => ({ ...prev, [selectedPlan.plan_name]: resp[0] }));
		history.push(`?step=${step}&stage=2`);

		// history.push({
		// 	pathname: location.pathname,
		// 	search: `?step=${step}&stage=2`,
		// 	state: resp
		// });
	}, [
		anotherInsurance.another_group_insurance,
		coveredDependents,
		employeePremium,
		isDependentExists,
		enrollmentStandardDetails,
		getEnrollmentInitData,
		groupOwner,
		history,
		member,
		selectedPlan,
		openEnrollment,
		totalPremium,
		// premiumAmountForAlwaysOpenEnrollment,
		urlSearchParams,
		isAgreed,
		beneficieryDetailsList,
		validateGLIBeneficieryDetails,
		currentPlanShouldEnroll
	]);

	// const checkPlanDependenciesEnrolledPriority = useCallback(async () => {
	// 	try {
	// 		let plan_dependencies_array: any = [];

	// 		if (selectedPlan.plan_dependencies && selectedPlan.plan_dependencies.length > 0) {
	// 			plan_dependencies_array = selectedPlan.plan_dependencies
	// 				.filter((plan: any) => plan.is_taken_together)
	// 				.map((plan: any) => ({
	// 					plan_name: plan.plan_name,
	// 					plan_code: plan.plan_code
	// 				}));
	// 		}

	// 		if (plan_dependencies_array.length == 0) {
	// 			return;
	// 		}
	// 		// console.log("plandependencies", plan_dependencies_array);
	// 		// const checkPreviousPayload: CheckPreviousCoreEnrollmentQueryTypes & any = {
	// 		// 	group_number,
	// 		// 	// insured_SSN: SSN,
	// 		// 	status: "ACTIVE",
	// 		// 	$or: JSON.stringify(plan_dependencies_array)
	// 		// };

	// 		// const response = await trackPromise(api.plan.getParticularPlans(checkPreviousPayload));

	// 		const getBenefitsQuery: any = {
	// 			group_number: member.group_number,
	// 			insured_SSN: member.SSN,
	// 			// member_SSN: member.SSN,
	// 			// status: "ACTIVE",
	// 			plan_dependencies: JSON.stringify(plan_dependencies_array)
	// 		};
	// 		const response: any = await trackPromise(api.enrollment.getBenefitsV2(getBenefitsQuery));

	// 		if (response && response.core.length > 0) {
	// 			// for (let idx = 0; idx < response.length; idx++) {
	// 			// 	const eachPlan = response[idx];
	// 			// 	if (eachPlan.plan_name === BBI_PLAN_NAMES.health_plan) {
	// 			// 		setHasPreviousCoreEnrollment(true);
	// 			// 	}
	// 			// }
	// 			const msg = [...new Set(response.core.map((plan: any) => plan.plan_name))].join(" ");
	// 			// console.log(msg, "testinggg");
	// 			setCurrentPlanShouldEnroll({
	// 				message: `${selectedPlan.plan_name} is already included in the plan of ${msg}, to enroll into cuurent plan ,please waive ${msg}`,
	// 				enroll: false
	// 			});
	// 		} else {
	// 			setCurrentPlanShouldEnroll({ enroll: true, message: "" });
	// 		}
	// 	} catch (e) {
	// 		console.log(e);
	// 	}
	// }, [member, selectedPlan]);

	const handleChangeOtherInsurance = useCallback(
		(event: any) => {
			const { name, value, checked } = event.target;

			if (name === "has_another_group_insurance") {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: checked }));
			} else {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: value }));
			}
		},
		[anotherInsurance]
	);

	const redirectBrochureDownloiad = () => {
		const pdfURL = Health_Plan_Brochure_SBC;
		const pdfTitle = "Health_Plan_Brochure SBC";
		window.open(pdfURL, pdfTitle);
	};

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	const handleCoverageLevelInputChange = (event: SelectChangeEvent) => {
		const { value } = event.target as HTMLSelectElement;

		// Update the selected plan
		setBasePlan(value);
		if (value === "" || !value) {
			{
				setCoverageDetails([]);

				setEligibleDependents([]);
				setBasePlanCoverageDetails({});
				calculatePremium();
			}
		}
	};

	const handleAddiotionalSubPlanChange = (event: SelectChangeEvent) => {
		const { value } = event.target as HTMLSelectElement;

		// Update the selected plan
		setSubPlan(value);
		if (value === "" || !value) {
			{
				setSubPlanCoveredDependents([]);
				setSubPlanEligibleDependents([]);
			}
		}
	};

	const formDeclaration = selectedPlan?.planDesign?.form_design?.form_declaration || "";
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = formDeclaration;
	const plainText = tempDiv.textContent?.trim() || "";

	// const handlePremiumAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
	// 	const { value } = event.target;
	// 	// console.log("value", value);
	// 	if (!/^[0-9 .]*$/.test(value)) {
	// 		// console.log("value insd", value);
	// 		return;
	// 	}

	// 	const numericValue = parseFloat(value);

	// 	// If less than 3, show alert
	// 	// if (numericValue < selectedPlan.custom_contribution_of_employees?.min_limit) {
	// 	// 	alert(
	// 	// 		`The contribution amount must be at least $${selectedPlan.custom_contribution_of_employees?.min_limit}`
	// 	// 	);
	// 	// }

	// 	// console.log("Number(value)", Number(value));
	// 	// setPremiumAmountForAlwaysOpenEnrollment(value);
	// 	setTotalPremium(value ? Number(value) : 0);
	// };

	const handlePremiumAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;

		if (!/^[0-9.]*$/.test(value)) return;

		const numericValue = Number(value);

		const minLimit = getMinContributionByPayFrequency(
			selectedPlan.custom_contribution_of_employees,
			paycheck?.pay_frequency
		);

		// optional: prevent typing below min
		if (numericValue && numericValue < minLimit) {
			// just allow typing, no alert here (UX friendly)
		}

		setTotalPremium(value ? numericValue : 0);
	};

	const handleAddBeneficiary = useCallback(async (beneficiaries: CommonBeneficiaryProps[]) => {
		// console.log("enrollmentPayload============> 444", beneficiaries);
		setBeneficieryDetailsList(beneficiaries);
	}, []);

	const getMinContributionText = (contributions?: { pay_frequency: string; min_limit: number }[]) => {
		if (!contributions || !Array.isArray(contributions) || contributions.length === 0) return "";

		return contributions.map((c) => `$${c.min_limit} per ${c.pay_frequency.toLowerCase()}`).join(" or ");
	};
	const getMinContributionByPayFrequency = (
		contributions?: { pay_frequency: string; min_limit: number }[],
		payFrequency?: string
	): number => {
		if (!contributions || !Array.isArray(contributions) || !payFrequency) return 0;

		const match = contributions.find((c) => c.pay_frequency.toUpperCase() === payFrequency.toUpperCase());

		return match?.min_limit ?? 0;
	};

	/* ===================== PREVIOUS-ENROLLMENT PREFILL =====================
	 * If previousEnrollments has an ACTIVE  enrollment for this plan_code,
	 * restore Base Plan, covered dependents, Add On Rider (+ its dependents), the other-insurance
	 * answer, beneficiaries and a custom contribution. Premiums are not restored; the existing
	 * effects recompute them at current rates. Runs once per plan_code.
	 * ===================================================================== */
	const handleFormAutofill = useCallback(() => {
		if (!selectedPlan || !member) return;
		if (autoFilledPlanCodeRef.current === selectedPlan.plan_code) return;
		autoFilledPlanCodeRef.current = selectedPlan.plan_code;


		const internalDependencies: any[] = selectedPlan.internal_dependencies ?? [];
		const requiredSubPlans = internalDependencies.filter((dep: any) => dep.sub_plan?.required === true);
		const optionalSubPlans = internalDependencies.filter((dep: any) => dep.sub_plan?.required === false);


		const isMainRow = (row: any) => row.plan_name === row.base_plan_name;

		const planRows: any[] = (previousEnrollments ?? []).filter(
			(row: any) =>
				row.plan_code === selectedPlan.plan_code && row.enrollment_status === "ACTIVE" && !row.termination_date
		);
		if (planRows.length === 0) return;


		const latestRow = (rows: any[]) =>
			rows.reduce((latest: any, row: any) => (!latest || String(row._id) > String(latest._id) ? row : latest), null);


		const empRow = latestRow(planRows.filter((row: any) => row.member_SSN === member.SSN && isMainRow(row)));
		if (!empRow) return;


		const enrollmentRows = planRows.filter(
			(row: any) => String(row.open_enrollment_id ?? "") === String(empRow.open_enrollment_id ?? "")
		);
		const dependentSSNsFor = (rows: any[]) =>
			new Set(rows.map((row: any) => row.member_SSN).filter((ssn: string) => ssn !== member.SSN));


		let restoredBasePlanCoverage: any;
		if (requiredSubPlans.length > 0 && empRow.sub_plan) {
			const match = requiredSubPlans.find((dep: any) => dep.sub_plan.name === empRow.sub_plan);
			if (match) {
				setBasePlan(match.sub_plan.name);
				restoredBasePlanCoverage = match.sub_plan.coverage;
			}
		}
		const basePlanResolved = requiredSubPlans.length === 0 || Boolean(restoredBasePlanCoverage);


		const mainCoverage = requiredSubPlans.length > 0 ? restoredBasePlanCoverage : openEnrollment?.plan?.coverage;
		const mainEligibility =
			requiredSubPlans.length > 0 ? selectedPlan.dependent_eligibility : openEnrollment?.plan?.dependent_eligibility;

		const mainGridShown =
			(selectedPlan.dependent_eligibility?.length ?? 0) > 0 &&
			!(requiredSubPlans.length === 0 && selectedPlan.has_employee_custom_contribution);
		const mainDependentSSNs = dependentSSNsFor(enrollmentRows.filter(isMainRow));

		if (mainCoverage && mainGridShown && mainDependentSSNs.size > 0) {
			const { eligibleDependents: eligible } = getEligibleDependents(dependents, mainCoverage, mainEligibility);
			const restored = eligible.filter((d: Member) => mainDependentSSNs.has(d.SSN));
			if (restored.length > 0) setCoveredDependents(restored);
		}


		const riderRows = enrollmentRows.filter((row: any) => !isMainRow(row));
		const riderRow = latestRow(riderRows.filter((row: any) => row.member_SSN === member.SSN)) ?? latestRow(riderRows);

		const riderMatch = riderRow
			? optionalSubPlans.find((dep: any) => dep.sub_plan.name === riderRow.plan_name)
			: undefined;


		if (riderMatch && basePlanResolved) {
			setSubPlan(riderMatch.sub_plan.name);
			const riderDependentSSNs = dependentSSNsFor(
				riderRows.filter((row: any) => row.plan_name === riderMatch.sub_plan.name)
			);
			if (riderDependentSSNs.size > 0) {
				const { eligibleDependents: eligible } = getEligibleDependents(
					dependents,
					riderMatch.sub_plan.coverage,
					openEnrollment?.plan?.dependent_eligibility
				);
				const restored = eligible.filter((d: Member) => riderDependentSSNs.has(d.SSN));
				if (restored.length > 0) setSubPlanCoveredDependents(restored);
			}
		}


		if (empRow.has_another_group_insurance || empRow.another_group_insurance) {
			setAnotherInsurance({
				has_another_group_insurance: true,
				another_group_insurance: empRow.another_group_insurance ?? null
			});
		}


		if (selectedPlan.beneficiaries_required) {
			const toBeneficiaryState = (list: any[] | undefined, type: string, startId: number): CommonBeneficiaryProps[] =>
				(list ?? []).map((b: any, i: number) => ({
					id: startId + i,
					name: b.name ?? "",
					date_of_birth: b.date_of_birth ?? "",
					relationship: b.relationship ?? "",
					SSN: b.SSN ?? "",
					address: b.address ?? "",
					percentage: b.percentage != null ? String(b.percentage) : "",
					type
				}));
			const primary = toBeneficiaryState(empRow.primary_beneficiery, "primary_beneficiery", 1);
			const contingent = toBeneficiaryState(empRow.contingent_beneficiery, "contingent_beneficiery", primary.length + 1);
			const restored = [...primary, ...contingent];
			console.log("restored--", restored);
			if (restored.length > 0) {
				setBeneficieryDetailsList(restored);
				setBeneficiaryFormKey((key) => key + 1);
			}
		}


		if (selectedPlan.has_employee_custom_contribution) {
			const restoredAmount = Number(empRow.total_premium);
			if (restoredAmount > 0) {
				setTotalPremium(restoredAmount);
				setEmployeePremium(restoredAmount);
			}
		}
	}, [selectedPlan, member, previousEnrollments, openEnrollment, dependents]);

	useEffect(() => {
		handleFormAutofill();
	}, [handleFormAutofill]);



	useEffect(() => {
		const requiredPlans = selectedPlan?.internal_dependencies?.filter((dep: any) => dep.sub_plan.required === true);

		const firstSubPlan = requiredPlans?.[0]?.sub_plan?.name;

		// if (firstSubPlan) setSubPlan(firstSubPlan);
	}, [selectedPlan]);

	useEffect(() => {
		getSubPlanCoverageDetails();
	}, [subPlan, getSubPlanCoverageDetails]);

	useEffect(() => {
		if (openEnrollment && !basePlanDivision) {
			if (selectedPlan.has_employee_custom_contribution) {
				return;
			}
			const dependentCoverage = getEligibleDependents(
				dependents,
				openEnrollment.plan.coverage,
				openEnrollment.plan.dependent_eligibility
			);

			// console.log("DependentCoverage", dependentCoverage.eligibleDependents);
			setEligibleDependents(Object.assign([], dependentCoverage.eligibleDependents));
			getCoverageDetails();
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: openEnrollment.plan.dependent_eligibility.length > 0 ? true : false,
					eligibleDependents: Object.assign([], dependentCoverage.eligibleDependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});

			if (!selectedPlan.is_always_open) {
				setEligiblity({
					eligibleDependents: [...dependentCoverage.eligibleDependents],
					ineligibleRelationshipDependents: [...dependentCoverage.ineligibleRelationshipDependents],
					ineligibleDependents: [...dependentCoverage.ineligibleDependents]
				});
			}
		} else if (basePlanDivision && basePlan && Object.keys(basePlanCoverageDetails).length > 0) {
			const dependentCoverage = getEligibleDependents(
				dependents,
				basePlanCoverageDetails.coverage,
				selectedPlan.dependent_eligibility
			);

			// console.log("DependentCoverage", dependentCoverage.eligibleDependents);
			setEligibleDependents(Object.assign([], dependentCoverage.eligibleDependents));
			getCoverageDetails();
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: selectedPlan.dependent_eligibility.length > 0 ? true : false,
					eligibleDependents: Object.assign([], dependentCoverage.eligibleDependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});

			if (!selectedPlan.is_always_open) {
				setEligiblity({
					eligibleDependents: [...dependentCoverage.eligibleDependents],
					ineligibleRelationshipDependents: [...dependentCoverage.ineligibleRelationshipDependents],
					ineligibleDependents: [...dependentCoverage.ineligibleDependents]
				});
			}
		}
	}, [
		dependents,
		getCoverageDetails,
		openEnrollment,
		basePlanDivision,
		basePlan,
		basePlanCoverageDetails,
		selectedPlan,
		setEligiblity
	]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, coveredDependents.length, subPlancoverageDetails, basePlanCoverageDetails]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	useEffect(() => {
		if (basePlan) {
			const selectedBasePlan = selectedPlan.internal_dependencies.find(
				(dep: any) => dep.sub_plan.name === basePlan && dep.sub_plan.required === true
			);
			const selectedBasePlanCoverageDetails = selectedBasePlan ? selectedBasePlan.sub_plan : null;
			if (selectedBasePlanCoverageDetails) {
				setBasePlanCoverageDetails(selectedBasePlanCoverageDetails);
			} else {
				setBasePlanCoverageDetails(selectedPlan);
			}

			// const firstSubPlan = requiredPlans?.[0]?.sub_plan?.name;
		} else {
			const selectedBasePlan = selectedPlan.internal_dependencies.find(
				(dep: any) => dep.sub_plan.required === true
			);
			if (selectedBasePlan) {
				setBasePlanDivision(true);
			} else {
				setBasePlanDivision(false);
			}
		}
	}, [selectedPlan, basePlan]);

	useEffect(() => {
		if (basePlanDivision && basePlan && basePlan.length > 0) {
			getCoverageDetails();
		}
	}, [basePlanDivision, basePlan]);

	// useEffect(() => {
	// 	if (member) checkPlanDependenciesEnrolledPriority();
	// }, [checkPlanDependenciesEnrolledPriority, member]);

	// // console.log("anotherInsurance", anotherInsurance);
	// console.log("covereddependentselected--->", coveredDependents);
	// console.log("openEnrollment=====> 2", openEnrollment?.plan.plan_name);
	// console.log("eligibleDependents=====>", eligibleDependents);
	// console.log("corePlansForEmployeeClassSpecific=====99999999>", corePlansForEmployeeClassSpecific);
	// console.log("selectedPlan=====99999999>", selectedPlan);
	// console.log("member=====>", member);
	// console.log("setPremiumAmount=======>", premiumAmountForAlwaysOpenEnrollment);
	// console.log("eligibleDependents=====>", eligibleDependents);
	// console.log("subPlanCoverage=====>", subPlanCoverage);
	// console.log("subPlanEligibleDependents======>", subPlanEligibleDependents);
	// console.log(basePlanDivision, "subPlan=====>", subPlan);
	// console.log("subPlancoverageDetails=====>", subPlancoverageDetails);
	// console.log("coverageDetails=========>", coverageDetails);
	// console.log("enrollmentPayload============> 5555", beneficieryDetailsList);
	// console.log("coveredDependents===============>", coveredDependents);
	// console.log("totalPremium=====>", totalPremium);

	return (
		<>
			<div className="health-benefit">
				<Suspense fallback={<div />}>
					{!basePlanDivision ? (
						<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
					) : basePlanDivision && subPlan && subPlan.length > 0 ? (
						<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
					) : (
						<></>
					)}
				</Suspense>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog
							customFormDialogProps={customFormDialogProps}
							planName={openEnrollment?.plan.plan_name}
						/>
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<PlanHeader
							planName={openEnrollment?.plan.plan_name}
							planCode={openEnrollment?.plan.plan_code}
						/>
						<div className="theme-plan-section-margin" />
						{/* {selectedPlan.has_premium && selectedPlan.coverage.length > 0 ? (
							<CoverageDetails coverageDetails={coverageDetails} />
						) : null} */}
						{selectedPlan?.internal_dependencies?.length > 0 &&
							selectedPlan.internal_dependencies.some((item: any) => item.sub_plan?.required === true) ? (
							<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
								<div className="details-form-row">
									{/* <div className="details-form-label  required">Coverage Level</div> */}
									<div className="details-form-label  required">Base Plan</div>
									<Select
										value={basePlan}
										input={<CustomSelectInput />}
										style={{ width: "40%" }}
										name="basePlan"
										onChange={(event: SelectChangeEvent) => handleCoverageLevelInputChange(event)}
									>
										{[
											...selectedPlan.internal_dependencies.filter(
												(dep: any) => dep.sub_plan.required === true
											),
											""
										].map((dep: any, index: number) => (
											<MenuItem value={dep ? dep.sub_plan.name : ""} key={index}>
												{dep ? dep.sub_plan.name : "No Select"}
											</MenuItem>
										))}
									</Select>
								</div>
							</Grid>
						) : (
							<></>
						)}
						{selectedPlan?.has_premium ? (
							basePlanDivision ? (
								basePlan.length ? (
									<CoverageDetails coverageDetails={coverageDetails} />
								) : (
									<></>
								)
							) : (
								<CoverageDetails coverageDetails={coverageDetails} />
							)
						) : null}
						<div className="theme-plan-section-margin" />
						{eligibleDependents.length > 0 && selectedPlan.dependent_eligibility.length > 0 ? (
							<CoveredDependents
								dependents={eligibleDependents}
								selectedDependents={coveredDependents}
								handleSelectDependent={(event, dependents) =>
									handleSelectDependent(event, dependents, "basePlan")
								}
							/>
						) : eligibleDependents.length > 0 && selectedPlan.has_premium ? (
							<div className="grid-actions-container">
								<div className="grid-action-margin" />
								<Button
									variant="contained"
									className="plan-action-button"
									style={{
										float: "right",
										marginBottom: "1rem",
										color: theme.button.color,
										backgroundColor: theme.button.background_color
									}}
									onClick={handleAddDependentClick}
								>
									Add Dependent
								</Button>
							</div>
						) : null}
						<div className="theme-plan-section-margin" />
						{selectedPlan?.internal_dependencies?.length > 0 &&
							selectedPlan.internal_dependencies.some(
								(item: any) => item.sub_plan?.required === false
							) && (
								<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
									<div className="details-form-row">
										{/* <div className="details-form-label  required">Coverage Level</div> */}
										<div className="details-form-label  required">Add On Rider</div>
										<Select
											value={subPlan}
											input={<CustomSelectInput />}
											style={{ width: "40%" }}
											name="subPlan"
											disabled={basePlanDivision ? (basePlan ? false : true) : false}
											onChange={(event: SelectChangeEvent) =>
												handleAddiotionalSubPlanChange(event)
											}
										>
											{[
												...selectedPlan.internal_dependencies.filter(
													(dep: any) => dep.sub_plan.required === false
												),
												""
											].map((dep: any, index: number) => (
												<MenuItem value={dep ? dep.sub_plan.name : ""} key={index}>
													{dep ? dep.sub_plan.name : "No Select"}
												</MenuItem>
											))}
										</Select>
									</div>
								</Grid>
							)}
						{selectedPlan?.internal_dependencies &&
						selectedPlan.internal_dependencies.some((item: any) => item.sub_plan?.required === false) &&
						selectedPlan.has_premium &&
						subPlan ? (
							<CoverageDetails coverageDetails={subPlancoverageDetails} />
						) : null}
						<div className="theme-plan-section-margin" />
						{selectedPlan.internal_dependencies.some((item: any) => item.sub_plan?.required === false) &&
							subPlan ? (
							subPlanEligibleDependents.length > 0 ? (
								<CoveredDependents
									dependents={subPlanEligibleDependents}
									selectedDependents={subPlanCoveredDependents}
									handleSelectDependent={(event, dependents) =>
										handleSelectDependent(event, dependents, "subPlan")
									}
								/>
							) : (
								<div className="grid-actions-container">
									<div className="grid-action-margin" />
									<Button
										variant="contained"
										className="plan-action-button"
										style={{
											float: "right",
											marginBottom: "1rem",
											color: theme.button.color,
											backgroundColor: theme.button.background_color
										}}
										onClick={handleAddDependentClick}
									>
										Add Dependent
									</Button>
								</div>
							)
						) : null}
						{selectedPlan.has_premium ? (
							<div className="details-form-row" style={{ marginTop: "0rem", width: "100%" }}>
								<div className="details-form-label required">Total Premium Amount</div>
								<CustomInput
									value={numberToDollarStr(totalPremium.toFixed(2) as unknown as number)}
									disabled
								/>
							</div>
						) : null}
						{eligibleDependents.length > 0 && selectedPlan.dependent_eligibility.length > 0 ? (
							<>
								{/* <div className="theme-plan-section-margin" /> */}

								<div className="theme-plan-option-content theme-plan-section-margin">
									<Checkbox
										onClick={handleChangeOtherInsurance}
										name="has_another_group_insurance"
										checked={anotherInsurance.has_another_group_insurance}
										style={{ paddingLeft: 0 }}
									/>
									<p className="theme-plan-checkbox-label">
										<strong>
											ARE YOU OR YOUR DEPENDENTS COVERED UNDER ANOTHER GROUP INSURANCE POLICY
										</strong>
									</p>
								</div>
							</>
						) : null}
						<div>
							{anotherInsurance.has_another_group_insurance ? (
								<Suspense fallback={<div />}>
									<LazyCustomTextAreaInput
										name="another_group_insurance"
										value={anotherInsurance.another_group_insurance}
										onChange={handleChangeOtherInsurance}
										placeholder="Please mention the details here . . ."
									/>
								</Suspense>
							) : null}
						</div>
						{openEnrollment?.plan.plan_code === "HP-FT-2023" ||
						openEnrollment?.plan.plan_code === "HP-PTIN-2023" ? (
							<div className="disclaimer-container">
								<Alert severity="warning" sx={{ fontSize: "1rem" }}>
									<div className="disclaimer-message">
										Disclaimer:{" "}
										<strong className="disclaimer">
											After May 1, 2024 all Health Plan payroll deductions will be updated to
											reflect the new rates for the Plan year as shown below:
										</strong>
									</div>
									<DisclaimerTable payFrequency={paycheck?.pay_frequency} />
								</Alert>
							</div>
						) : null}
						{selectedPlan.has_premium ? (
							<>
								<div className="theme-plan-section-margin" />
								<div className="external-links">
									<div>
										<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
									</div>
									{/* <div className="header">
										To Know More About The Benefits Offered,{" "}
										<a href="#" onClick={redirectBrochureDownloiad}>
											Click Here
										</a>
									</div> */}
								</div>
							</>
						) : null}
						{/* <div className="theme-plan-section-margin" /> */}
						{selectedPlan.has_employee_custom_contribution ? (
							<div className="details-form-row" style={{ marginTop: "2rem", width: "100%" }}>
								{/* <div className="details-form-label required">
									The following amount of payment per applicable payroll period (minimum $3 per month
									or $ 1 per week) are to be deducted through Brookshire Brothers, Inc. Payroll for
									the purpose of depositing the funds into the {selectedPlan.plan_name}.
								</div> */}
								<div className="details-form-label required">
									The following amount of payment per applicable payroll period (minimum{" "}
									{getMinContributionText(selectedPlan.custom_contribution_of_employees)}) are to be
									deducted through Brookshire Brothers, Inc. Payroll for the purpose of depositing the
									funds into the {selectedPlan.plan_name}.
								</div>

								<CustomInput
									// value={premiumAmountForAlwaysOpenEnrollment}
									value={totalPremium}
									onChange={handlePremiumAmountChange}
								/>
								<div className="theme-plan-inner-section-margin" />
							</div>
						) : null}
						<div className="theme-plan-section-margin" />
						{selectedPlan.beneficiaries_required ? (
							<BeneficaryDetails
								beneficiary={beneficieryDetailsList}
								handleAddBeneficiary={handleAddBeneficiary}
								isPrintable={false}
							/>
						) : null}
						<div className="theme-plan-option-content theme-plan-section-margin">
							{/* <Checkbox defaultChecked style={{ paddingLeft: 0 }} /> */}
							<Checkbox
								checked={isAgreed}
								onChange={(e) => setIsAgreed(e.target.checked)}
								style={{ paddingLeft: 0 }}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>
									I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
									THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
								</strong>
							</p>
						</div>
						<div className="theme-plan-section-margin" />
						<Grid container className="theme-plan-section-margin">
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Signature</div>
									<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
								</div>
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Date</div>
									<CustomInput value={dateTimeZoneConverter(getCurrentDate())} disabled />
								</div>
							</Grid>
						</Grid>
						<div className="theme-plan-section-margin" />
						<PlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
							isWaiveLoading={isWaiveLoading}
						/>
					</Paper>
				</div>
			</div>
			{isModelOpen && <ExistsEnrollmentModel onClose={() => setIsModelOpen(false)} />}
			{isDependentExistsModelOpen && (
				<ExistsDependentModel
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default DynamicEnrollmentPlanForm;
